import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActionService } from './action.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [],
})
export class ActionModule {

}
